
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/suche",
      function () {
        return require("private-next-pages/[lang]/suche/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/suche"])
      });
    }
  